export const ignoreField = { isRequired: false, name: 'Ignore', id: 0 };

export const fields = [
  ignoreField,
  { isRequired: true, name: 'City *', id: 1 },
  { isRequired: true, name: 'Country *', id: 2 },
  { isRequired: true, name: 'Recipient Name *', id: 4 },
  { isRequired: true, name: 'Street Line 1 *', id: 5 },
  { isRequired: true, name: 'Zip/Postal Code *', id: 6 },
  { isRequired: false, name: 'Email', id: 3 },
  { isRequired: false, name: 'Company', id: 7 },
  { isRequired: false, name: 'Phone', id: 8 },
  { isRequired: false, name: 'State/Province', id: 9 },
  { isRequired: false, name: 'Street Line 2', id: 10 },
  { isRequired: false, name: 'Street Number', id: 11 },
  { isRequired: false, name: 'Order Date', id: 12 },
  { isRequired: false, name: 'Order Number', id: 13 },
  { isRequired: false, name: 'Order Amount', id: 14 },
  { isRequired: false, name: 'Order Currency', id: 15 },
  { isRequired: false, name: 'Order Weight', id: 16 },
  { isRequired: false, name: 'Order Weight Unit', id: 17 },
  { isRequired: false, name: 'Item Title', id: 18 },
  { isRequired: false, name: 'Quantity', id: 19 },
  { isRequired: false, name: 'SKU', id: 20 },
  { isRequired: false, name: 'Item Price', id: 21 },
  { isRequired: false, name: 'Item Currency', id: 22 },
  { isRequired: false, name: 'Item Weight', id: 23 },
  { isRequired: false, name: 'Item Weight Unit', id: 24 },
  { isRequired: false, name: 'Item Country of Origin', id: 25 },
];

export function fieldToSelectOption(field) {
  return {
    isRequired: field.isRequired,
    label: field.name,
    value: field.id,
  };
}

export const fieldsAsSelectOptions = fields.map(fieldToSelectOption);

export default fields;
